module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BwRJaR/images/e9781439626160_cover.jpg?1684515368263",
      "alt": "This image is the cover for the book Ijams Nature Center, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ijams Nature Center, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ijams Nature Center, on the banks of the Tennessee River, evolved from humble beginnings during the early 20th century into a natural showplace known as the Island Home Bird Sanctuary. Developed by Harry Ijams, Knoxville�s leading ornithologist, and Alice Yoe Ijams, �First Lady of Knoxville Garden Clubs,� the Ijams property has been a gathering point for birders and nature-lovers for more than a century. Girl Scouting has been a fixture at Ijams since 1923, followed by Camp Mary Ijams, and Camp Margaret Townsend in the Smokies was created in part through Ijams and Townsend family ties. Harry Ijams also helped establish the first official campsite on Mount LeConte and used his artistry as a commercial illustrator to promote the Smoky Mountains as a national park. Over the years, Ijams Nature Center has grown in size and stature to become the region�s leading wildlife sanctuary and environmental learning center incorporating Mead�s Quarry, which in its heyday produced Tennessee marble used both in local buildings and national monuments.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul James\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author Paul James, executive director at Ijams Nature Center, chronicles the Ijams legacy and development of the wildlife sanctuary through a fascinating collection of vintage photographs, maps, and illustrations from the Ijams family archives and local sources.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0